module.exports = __webpack_public_path__ + "static/media/portfolio_1.653edba7.jpeg";